// extracted by mini-css-extract-plugin
module.exports = {"HeaderTitle":"styles_HeaderTitle__1wHjs"};